export default __webpack_public_path__ + "static/media/topSmallLandrangerBackground.05d6c455.jpg";